<template>
    <div class="login-dialog overflow-hidden w-[400px] min-h-[480px] border border-white rounded-3xl bg-white">
        <div class="w-full relative login-dialog_header pt-8 px-10 pb-6">
            <PtIcon v-if="!withoutClose" icon="SolidCloseBig" @click="close"
                    class="text-2xl absolute right-6 top-6 cursor-pointer fill-gray-450">
            </PtIcon>
            <div class="text-2xl leading-8 font-semibold">
                {{ title || t('register_or_login') }}
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg'

const { t } = useI18n()

defineProps<{
    withoutClose?: boolean;
    title?: string;
}>()

const emits = defineEmits<{
    (e: 'close'): void;
}>();

function close() {
    emits('close')
}

</script>

<style lang="scss">
.login-dialog {
    &_header {
        background-image: url('./img/bg_header.png');
        @apply bg-cover bg-center bg-no-repeat;
    }
}
</style>
